<template>
  <div v-click-outside="() => (isOpen = false)" style="position:relative">
    <button
        type="button"
        class="flex items-center text-base focus:ring-2 font-medium border-blue-700 text-blue-700 bg-blue-50 w-9 h-9 justify-center rounded-md"
        aria-expanded="false"
        @click="toggle"
    >
      <span>{{ text }}</span>
      <v-icon style="color: inherit;">mdi-filter-outline</v-icon>
      <!-- <img src="../assets/svg/seting.svg"> -->
    </button>
    <transition
        enter-class="-translate-y-1 opacity-0 "
        enter-to-class="translate-y-0 opacity-100 "
        enter-active-class="transition ease-out duration-50"
        leave-class="translate-y-0 opacity-100 "
        leave-to-class="-translate-y-1 opacity-0 "
        leave-active-class="transition duration-150 ease-in"
    >
      <template
          v-if="isOpen"
      >
        <v-card style="position: absolute;max-width: unset;width: 200px;left: 0;top: 100%;max-height: 300px;overflow: auto;z-index: 10">
          <template>
            <div :class="[item.status ? 'bg-stone-50': '']" class="m-2 hover:bg-stone-50 transition-all duration-200 rounded-md px-2 py-2 cursor-pointer" @click="item.status = !item.status, filterSelect(item, i)" v-for="(item,i) in headers" :key="i">
              <!-- <div style="display: flex">
                <div style="margin-right: 22px">
                  <v-checkbox v-model="item.status" @click="filterSelect(item, i)"></v-checkbox>
                </div>
                <div style="padding-top: 15px">
                  <span>{{ item.text }}</span>
                </div>
              </div>
              <v-divider></v-divider> -->
                <div class="flex items-center justify-between">
                  <span class="text-sm">{{ item.text }}</span>
                  <v-icon v-if="item.status" color="blue" size="20" class="mr-2">mdi-eye</v-icon>
                  <v-icon v-else size="20" class="mr-2">mdi-eye-off-outline</v-icon>
                </div>
            </div>              
          </template>
        </v-card>
      </template>
    </transition>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
export default {
  name: "FilterSelect",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: ['text','headers','headersSelected'],
  data() {
    return {
      isOpen: false,
      headersLocal: [],
      localName: `${this.$route.name}-setting`,
    }
  },
  watch: {
    $route() {
      this.isOpen = false
    },
  },
  methods: {
    getHeaderFromLocal(){
      if (localStorage.getItem(this.localName) || localStorage.getItem(this.localName)?.length > 0) {
        this.headersLocal = JSON.parse(localStorage.getItem(this.localName))
        this.headers.forEach(objItem => {
          !this.headersLocal.includes(objItem.text) ?  objItem.status = false : objItem.status = true
        })
        this.$emit('filterSelect', this.headers.filter(header => header.status === true))
      }
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    filterSelect() {
      let nameFilter = []
      this.headersLocal = this.headers.filter(header => header.status === true)
      this.headersLocal.forEach(i => nameFilter.push(i.text))
      localStorage.setItem(this.localName, JSON.stringify(nameFilter))
      this.$emit('filterSelect', this.headers.filter(header => header.status === true))
    }
  },
  mounted(){
    this.getHeaderFromLocal()
  },
}
</script>

<style scoped>
</style>